import Delivery from '../src/Delivery/index';
export default Delivery;
